"use strict";
/** family: Table **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var FontAwesome_1 = require("../FontAwesome");
var IconWrapper_1 = require("../IconWrapper");
var TableCell_1 = require("../TableCell");
var CLASS_NAME = 'i-table__row';
/**
 * The row subcomponent for a table.
 *
 * TableRow should only be used inside a Table.Head or Table.Body.
 * On mobile, if table has columns set to expand on mobile, row will be clickable to expand to show these.
 */
var TableRow = /** @class */ (function (_super) {
    __extends(TableRow, _super);
    function TableRow(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyboard = function (e) {
            // If enter is pressed while out tableRow is in focus, toggle it
            if (e.key === 'Enter') {
                var focusedId = document.activeElement && document.activeElement.id;
                if (focusedId && focusedId === _this.props.rowId) {
                    _this.toggleExpanded();
                }
            }
        };
        _this.toggleExpanded = function () {
            _this.setState(function (_a) {
                var expandedOnMobile = _a.expandedOnMobile;
                return ({
                    expandedOnMobile: !expandedOnMobile,
                });
            });
        };
        _this.renderHeaderRow = function (className, classesChevron, mobileOptions, children, restProps, isHeader) {
            var classesHeader = classNames(className, CLASS_NAME + "__header-row");
            return _this.renderRow(classesChevron, mobileOptions, children, restProps, isHeader, classesHeader);
        };
        _this.renderDesktopRow = function (className, classesChevron, mobileOptions, children, restProps, isHeader) {
            var classesMainRow = classNames(className, CLASS_NAME + "__main-row", 'd-none', 'd-sm-table-row');
            return _this.renderRow(classesChevron, mobileOptions, children, restProps, isHeader, classesMainRow);
        };
        _this.renderRow = function (classesChevron, mobileOptions, children, restProps, isHeader, rowClasses) {
            var chevron = isHeader ? (React.createElement("th", { className: classesChevron })) : (React.createElement("td", { className: classesChevron }));
            return (React.createElement("tr", __assign({ className: rowClasses }, restProps),
                chevron,
                React.Children.map(children, function (cell, index) {
                    return cell
                        ? React.cloneElement(cell, {
                            isHeader: isHeader,
                            mobileView: cell.props.mobileView
                                ? cell.props.mobileView
                                : mobileOptions &&
                                    mobileOptions.length > index
                                    ? mobileOptions[index]
                                    : undefined,
                        })
                        : cell;
                })));
        };
        _this.renderMobileRow = function (className, classesChevron, mobileOptions, children, restProps, expandedOnMobile, rowId) {
            var classesMobile = classNames(className, CLASS_NAME + "__mobile-main-row", 'd-table-row', 'd-sm-none');
            return (React.createElement("tr", __assign({ className: classesMobile }, restProps, { onClick: _this.toggleExpanded, tabIndex: 0, "aria-expanded": expandedOnMobile, id: rowId }),
                React.createElement("td", { className: classesChevron },
                    React.createElement(IconWrapper_1.IconWrapper, null,
                        React.createElement(FontAwesome_1.FontAwesome, { name: "chevron-right", rotate: expandedOnMobile
                                ? FontAwesome_1.FontAwesome.Rotation.Deg90
                                : null }))),
                React.Children.map(children, function (cell, index) {
                    return cell
                        ? React.cloneElement(cell, {
                            mobileView: cell.props.mobileView
                                ? cell.props.mobileView
                                : mobileOptions &&
                                    mobileOptions.length > index
                                    ? mobileOptions[index]
                                    : undefined,
                        })
                        : cell;
                })));
        };
        _this.renderMobileExpandedRows = function (className, classesChevron, mobileOptions, children, header) {
            var classesExpanded = classNames(className, CLASS_NAME + "__mobile-expand-rows", 'd-table-row', 'd-sm-none');
            return React.Children.map(children, function (cell, index) {
                var expandOnMobile = mobileOptions &&
                    mobileOptions.length > index &&
                    mobileOptions[index] === TableCell_1.TableMobileView.DisplayOnExpand;
                if (expandOnMobile) {
                    return (React.createElement("tr", { className: classesExpanded },
                        React.createElement("td", { className: classesChevron }),
                        header && header.length > index && header[index]
                            ? React.cloneElement(header[index], {
                                mobileView: null,
                            })
                            : header[index],
                        cell));
                }
            });
        };
        _this.state = {
            expandedOnMobile: false,
        };
        return _this;
    }
    TableRow.prototype.componentDidMount = function () {
        window.addEventListener('keydown', this.handleKeyboard);
    };
    TableRow.prototype.componentWillUnmount = function () {
        window.removeEventListener('keydown', this.handleKeyboard);
    };
    TableRow.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, isHeader = _a.isHeader, mobileOptions = _a.mobileOptions, header = _a.header, rowId = _a.rowId, restProps = __rest(_a, ["className", "children", "isHeader", "mobileOptions", "header", "rowId"]);
        var expandedOnMobile = this.state.expandedOnMobile;
        var classesChevron = classNames(CLASS_NAME + "__chevron-spacer", 'd-table-cell', 'd-sm-none');
        var headerRow = null;
        var desktopRow = null;
        var mobileRow = null;
        var mobileExpandedRows = null;
        if (isHeader) {
            headerRow = this.renderHeaderRow(className, classesChevron, mobileOptions, children, restProps, isHeader);
        }
        else {
            desktopRow = this.renderDesktopRow(className, classesChevron, mobileOptions, children, restProps, isHeader);
            mobileRow = this.renderMobileRow(className, classesChevron, mobileOptions, children, restProps, expandedOnMobile, rowId);
            if (expandedOnMobile) {
                mobileExpandedRows = this.renderMobileExpandedRows(className, classesChevron, mobileOptions, children, header);
            }
        }
        return (React.createElement(React.Fragment, null,
            headerRow,
            desktopRow,
            mobileRow,
            mobileExpandedRows));
    };
    return TableRow;
}(React.Component));
exports.TableRow = TableRow;
//# sourceMappingURL=TableRow.js.map